module.exports = __webpack_public_path__ + "static/img/advantage2.c00c1f18.png";